import { MapperKeys } from '@common/utils/query/dataMappers';
import { BackendMediaCustomFields, BackendSearchClip, Clip } from './types';
import { BackendWorkflowEntry, WorkflowEntry } from './types/workflow';

export const CLIP_KEYS: MapperKeys<BackendSearchClip, Partial<Clip>> = {
    id: 'id',
    mediaObjectId: 'mediaObjectId',
    mediaObjectType: 'mediaObjectType',
    clipName: 'mediaObjectName',
    title: 'cf_s_value_title',
    episode: 'cf_s_value_episode',
    customer: 'cf_s_value_customer',
    commercialOffer: 'cf_s_value_commercialOffer',
    size: 'cf_s_value_size',
    preservationCategory: 'cf_s_value_preservation_category',
    checksumCheck: 'cf_t_value_checksumCheck',
    lto: 'cf_s_value_ltoNumber',
    container: 'cf_s_value_container',
    codec: 'cf_s_value_codec',
    bitRate: 'cf_s_value_bitRate',
    aspectRatio: 'cf_s_value_aspectratio',
    audioMapping: 'audioMapping',
    created: 'mediaObjectCreated',
    updated: 'lastUpdated',
    status: 'cf_s_value_MPMStatus',
    collectionId: 'attachedEditorialObjectParentId',
    mediaIdentifiers: undefined,

    // Technical
    // fps: 'technical_s_fps_human_s',
    fps: 'technical_s_fps_s',
    resolution: 'technical_s_resolution',
};

export const DIRECT_CLIP_CUSTOM_FIELD_KEYS: MapperKeys<
    BackendMediaCustomFields,
    Partial<Clip>
> = {
    title: 'title',
    episode: 'episode',
    customer: 'customer',
    commercialOffer: 'commercialOffer',
    preservationCategory: 'preservation_category',
    status: 'workflowStatus',
    lto: 'ltoNumber',
    container: 'container',
    codec: 'codec',
    bitRate: 'bitRate',
    checksumCheck: 'checksumCheck',
    size: 'size',
    aspectRatio: 'aspectratio',
};

export const WORKFLOW_KEYS: MapperKeys<BackendWorkflowEntry, WorkflowEntry> = {
    id: 'id',
    clipName: 'mediaObjectName',
    label: 'label',
    type: 's_startupParameters_workflowType',
    status: 'status',
    created: 'created',
    updated: 'lastUpdated',
    completed: 'completed',
    duration: 'duration',
    userName: 'userName',
};
